import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSnapTarget, setAllSnapTargets } from '../../../../redux/modsSlice';

const SNAP_TARGETS = [
  { key: 'mimariCizim', label: 'Mimari Cizim' },
  { key: 'kullaniciCizim', label: 'Kullanici Cizimleri' },
  { key: 'tesisatCizim', label: 'Tesisat Cizimleri' },
  { key: 'dokumanlar', label: 'Dokumanlar' },
];

export default function DrawingModsTab() {
  const dispatch = useDispatch();
  const snapTargets = useSelector(state => state.mods.snapTargets);
  const [openSections, setOpenSections] = useState({ snap: true });
  const allCheckboxRef = useRef(null);

  const allValues = Object.values(snapTargets);
  const allChecked = allValues.every(Boolean);
  const noneChecked = allValues.every(v => !v);

  useEffect(() => {
    if (allCheckboxRef.current) {
      allCheckboxRef.current.indeterminate = !allChecked && !noneChecked;
    }
  }, [allChecked, noneChecked]);

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
  };

  return (
    <div className="panel-detail-tab">
      <div className="detail-accordion">
        <button
          className="detail-accordion-header"
          onClick={() => toggleSection('snap')}
        >
          <span className="detail-accordion-arrow">
            {openSections.snap ? '\u25BC' : '\u25B6'}
          </span>
          Snap Modu
        </button>
        {openSections.snap && (
          <div className="detail-section-content">
            <div className="detail-checkbox-col">
              <label>
                <input
                  ref={allCheckboxRef}
                  type="checkbox"
                  checked={allChecked}
                  onChange={() => dispatch(setAllSnapTargets(!allChecked))}
                />
                Hepsi
              </label>

              {SNAP_TARGETS.map(({ key, label }) => (
                <label key={key} style={{ paddingLeft: 16 }}>
                  <input
                    type="checkbox"
                    checked={snapTargets[key]}
                    onChange={e => dispatch(setSnapTarget({ key, value: e.target.checked }))}
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
